export const CHANGE_IMPORT_PAGE = 'CHANGE_IMPORT_PAGE';
export function changeImportPage(page) {
  return { page: page, type: CHANGE_IMPORT_PAGE };
}
